import React, { Suspense, lazy } from "react";
import { ThemeProvider } from "./providers/ThemeProvider";
import ColorThemeProvider from "./components/ColorThemeProvider";

const ChatInterface = lazy(() => import("./components/ChatInterface"));

function App() {
    return (
        <ThemeProvider>
            <ColorThemeProvider>
                <div className="min-h-screen bg-background">
                    <Suspense
                        fallback={
                            <div className="flex items-center justify-center min-h-screen">
                                <div className="text-lg">Loading...</div>
                            </div>
                        }
                    >
                        <ChatInterface />
                    </Suspense>
                </div>
            </ColorThemeProvider>
        </ThemeProvider>
    );
}

export default App;
